import { formatAccountNumber } from "../../../_utils/FormatAccountNumber/index";
import { useSelector } from "react-redux";
import formatTotalBalance from "../../../../utils/formatTotalBalance";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import { useLocation } from "react-router-dom";
import CardActionableButton from "../../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import ICONS from "../../../../assets/Icons";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";

const OwnerAccountGridViewComp = ({
  navigate,
  account,
  isopen,
  setRefreshtype,
  total_balance,
  setPrev_Total_balance_state,
  setFailedRefreshId,
  failedRefreshId,
  successRefreshId,
  setSuccessRefreshId,
  currency,
  refreshAll,
  typepop,
  txnPayLoad,
  setTxnPayLoad,
  handleButtonClick,
  setOpenOwner,
  flow,
  handleViewStatement,
  handleClick,
  ownerAccBalanceLoading,
  accId,
  setAccId,
  setStatementId,
  setAccData,
  prevId,
  setPrevId,
  prevBalance,
  setPrevBalance,
  multiSelect,
  isAssignTagsClicked,
  owneraccountnumberstate,
  setowneraccountnumberstate,
  isLabelClicked,
  handleOwnerAccountSelect,
  TypeRTGS,
  currentAccountDetails,
  filterRef,
}) => {
  const location = useLocation();
  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const services = useSelector((state) => state.refreshToken.services);
  const shouldBeRedacted = (price) => {
    return (
      price === "xxxx.xx" ||
      isNaN(+price) ||
      price === null ||
      price === undefined
    );
  };
  const service =
    services?.includes("VAccountBalance") || services?.includes("Admin");
  const isAccountSelected = owneraccountnumberstate?.some
    ? owneraccountnumberstate.some((selectedAccount) =>
        typeof selectedAccount === "object"
          ? selectedAccount?.id === account?.id
          : selectedAccount === account?.id,
      )
    : false;

  return (
    <>
      <div
        key={account?.id}
        style={{
          height: GlobalConfiguration.OwnerCardMinHeight,
          position: "relative",
          opacity:
            (typepop === "popup" &&
              account?.connected_banking === "N" &&
              flow !== "internalTxn") ||
            isopen
              ? "var(--light-opacity)"
              : "var(--base-opacity)",
          pointerEvents:
            typepop === "popup" &&
            account?.connected_banking === "N" &&
            flow !== "internalTxn"
              ? "none"
              : isopen
                ? "none"
                : "auto",
        }}
      >
        <CardContainer
          hoverHeight={
            successRefreshId?.includes(account?.id) ||
            failedRefreshId?.includes(account?.id)
              ? GlobalConfiguration.ownerAccountCardHoverHeightWithRefresh
              : GlobalConfiguration.ownerAccountCardHoverHeightWithoutRefresh
          }
          minHeight={GlobalConfiguration.OwnerCardMinHeight}
          ownerviewall={true}
          filterRef={filterRef}
          context={account}
          isSelected={
            (multiSelect || isAssignTagsClicked || isLabelClicked) &&
            isAccountSelected
          }
          isDisabled={
            (typepop === "popup" &&
              account?.connected_banking === "N" &&
              flow !== "internalTxn") ||
            isopen ||
            (account?.pan_no === txnPayLoad?.pan &&
              account?.bank_acc_no === txnPayLoad?.bankAccountNo &&
              account?.ifsc_code === txnPayLoad?.bankAccountIFSC &&
              flow === "createTxn")
          }
          onClickHandler={async (e) => {
            if (isAssignTagsClicked || isLabelClicked) {
              e.stopPropagation();

              if (handleOwnerAccountSelect) {
                handleOwnerAccountSelect(account);
              } else if (owneraccountnumberstate?.includes(account?.id)) {
                setowneraccountnumberstate(() => {
                  return owneraccountnumberstate?.filter((acc) => {
                    return acc !== account?.id;
                  });
                });
              } else {
                if (
                  owneraccountnumberstate.length >=
                  PaginationConfiguration.paginationBig
                )
                  return;
                setowneraccountnumberstate([
                  ...owneraccountnumberstate,
                  account?.id,
                ]);
              }
            } else if (typepop === "popup") {
              if (multiSelect) {
                e.stopPropagation();
                handleOwnerAccountSelect(account);
              } else if (flow === "createTxn") {
                setTxnPayLoad({
                  ...txnPayLoad,
                  ownerId: account?.id,
                  ownerBankIFSC: account?.ifsc_code,
                  ownerBankBalance: account?.owner_account_balance,
                  ownerBankLogo: account?.bank_name,
                  ownerLastUpdated:
                    account?.owner_account_balance_last_fetched_at_in_words,
                  ownerBankAccountNo: account?.bank_acc_no,
                  ownerBankAccountName: account?.bank_account_holder_full_name,
                  ownerPan: account?.pan_no,
                  settleType:
                    TypeRTGS === "RequestRTGS"
                      ? Number(currentAccountDetails.amount) >
                        Number(GlobalConfiguration?.settleTypeValue)
                        ? "rtgs"
                        : "neft"
                      : "neft",
                  ownerLabels: [...(account?.labels || [])],
                });
                if (flow === "createTxn") {
                }
              } else if (flow === "internalTxnSource") {
                setTxnPayLoad({
                  ...txnPayLoad,
                  ownerId: account?.id,
                  ownerBankIFSC: account?.ifsc_code,
                  ownerBankBalance: account?.owner_account_balance,
                  ownerBankLogo: account?.bank_name,
                  ownerLastUpdated:
                    account?.owner_account_balance_last_fetched_at_in_words,
                  ownerBankAccountNo: account?.bank_acc_no,
                  ownerBankAccountName: account?.bank_account_holder_full_name,
                  ownerPan: account?.pan_no,
                  settleType: "neft",
                  ownerLabels: [...(account?.labels || [])],
                });

                if (flow === "createTxn") {
                }
              } else if (flow === "ReimbursementRequestMultiFlow") {
                handleButtonClick(account);
              } else if (flow === "txnViewAll") {
                if (e && e.stopPropagation) {
                  e.stopPropagation();
                }
                handleButtonClick(account);
              }

              if (!multiSelect) {
                setOpenOwner(false);
              }
            } else {
              let selection = window.getSelection();
              if (!selection.toString().length) {
                if (!isopen) {
                  navigate(
                    `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${account?.id}`,
                    {
                      state: {
                        isViewAll:
                          location.pathname ===
                          "/owner_account_dashboard/owner_accounts_view_all"
                            ? true
                            : false,
                      },
                    },
                  );
                }
              }
            }
          }}
        >
          <card-body>
            <div className="flex flex-col px-mobile-padding-l Qmd:px-padding-sm gap-y-gap-xs">
              <div className="w-full flex justify-between items-center">
                <div className="flex gap-x-gap-sm items-center">
                  <p
                    className={`text-font-sm flex-1 truncate ${
                      account?.owner_account_balance
                        ? account?.owner_account_balance <
                          GlobalConfiguration.lengthCheckZero
                          ? "text-failed font-semibold"
                          : "text-settled font-semibold"
                        : "text-text-primary font-normal"
                    }`}
                  >
                    {account?.owner_account_balance
                      ? `
                      ${shouldBeRedacted(account?.owner_account_balance) ? "" : "INR "}
                      ${
                        formatTotalBalance(
                          Number(account?.owner_account_balance),
                          currency,
                        ).amount
                      }
                       ${formatTotalBalance(Number(account?.owner_account_balance), currency).abbr}
                   `
                      : flow === "internalTxn"
                        ? "For Internal purpose only"
                        : "Not available"}
                  </p>

                  {account.connected_banking == "Y" ? (
                    ownerAccBalanceLoading && accId === account?.id ? (
                      <CardActionableButton
                        handleFunction={() => {}}
                        icon={ICONS?.LOADER_GIF}
                        isDisabled={false}
                        title={""}
                      />
                    ) : failedRefreshId.includes(account?.id) ? (
                      <CardActionableButton
                        handleFunction={() => {}}
                        icon={ICONS?.ERROR_WITH_ORANGE_CIRCLE}
                        isDisabled={false}
                        title={"Balance fetch failed"}
                      />
                    ) : !ownerAccBalanceLoading &&
                      account?.id === prevId &&
                      prevBalance !== undefined &&
                      Number(account?.owner_account_balance) !==
                        Number(prevBalance) ? (
                      Number(account?.owner_account_balance) >
                        Number(prevBalance) ||
                      Number(account?.owner_account_balance) <
                        Number(prevBalance) ? (
                        <CardActionableButton
                          handleFunction={() => {}}
                          icon={
                            Number(account?.owner_account_balance) >
                            Number(prevBalance)
                              ? ICONS?.ARROW_UP_GREEN_GIF
                              : Number(account?.owner_account_balance) <
                                  Number(prevBalance)
                                ? ICONS?.ARROW_DOWN_RED_GIF
                                : undefined
                          }
                          isDisabled={false}
                          title={"Balance updated"}
                        />
                      ) : null
                    ) : null
                  ) : null}
                </div>

                {multiSelect || isAssignTagsClicked || isLabelClicked ? (
                  <div className="gap-x-gap-sm ml-margin-sm justify-end">
                    <CardActionableButton
                      handleFunction={() => {}}
                      icon={
                        isAccountSelected
                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                      }
                      isDisabled={false}
                      title={"Select account"}
                    />
                  </div>
                ) : account.connected_banking == "Y" ? (
                  <div className="gap-x-gap-sm ml-margin-sm justify-end flex">
                    {service && (
                      <>
                        <CardActionableButton
                          bgColor="var(--primary-nav)"
                          handleFunction={(e) => {
                            if (
                              !ownerAccBalanceLoading &&
                              !isopen &&
                              !refreshAll
                            ) {
                              if (
                                services.includes("VAccountBalance") ||
                                services?.includes("Admin")
                              ) {
                                e.stopPropagation();
                                setFailedRefreshId([]);
                                setSuccessRefreshId([]);
                                setAccId(account?.id);
                                setRefreshtype("single");
                                handleClick(e, account?.id);
                                setPrevId(account?.id);
                                setPrevBalance(account?.owner_account_balance);
                                setPrev_Total_balance_state(total_balance);
                              } else {
                                e.stopPropagation();
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "VAccountBalance,Admin",
                                  },
                                });
                              }
                            } else {
                              e.stopPropagation();
                            }
                          }}
                          icon={ICONS?.RELOAD_REFRESH_WHITE}
                          isDisabled={
                            !(
                              services?.includes("VAccountBalance") ||
                              services?.includes("Admin")
                            ) ||
                            ownerAccBalanceLoading ||
                            refreshAll
                          }
                          title={"Refresh balance"}
                        />
                      </>
                    )}
                    <CardActionableButton
                      bgColor="var(--primary-nav)"
                      handleFunction={(e) => {
                        if (typepop === "popup") {
                          return actionRestricted();
                        } else if (
                          services?.includes("VAccountBalance") ||
                          services?.includes("Admin")
                        ) {
                          if (!isopen && account?.connected_banking === "Y") {
                            e.stopPropagation();
                            setAccData(account);
                            setStatementId(account?.id);
                            handleViewStatement();
                          }
                        } else {
                          e.stopPropagation();
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VAccountBalance,Admin",
                            },
                          });
                        }
                      }}
                      icon={ICONS?.VIEW_STATEMENT_OUTLINE}
                      isDisabled={
                        !(
                          services?.includes("VAccountBalance") ||
                          services?.includes("Admin")
                        ) || typepop === "popup"
                      }
                      title={"Bank statement"}
                    />
                  </div>
                ) : (
                  <div className="invisible pointer-events-none">
                    <CardActionableButton
                      bgColor="var(--primary-nav)"
                      handleFunction={() => {}}
                      icon={ICONS?.LOADER_GIF}
                      isDisabled={false}
                      title={""}
                    />
                  </div>
                )}
              </div>
              <p
                className="text-font-xs transform-none text-text-secondary"
                style={{
                  display: "flex",
                }}
              >
                Balance
              </p>
            </div>

            <TextWithIcon
              text={formatAccountNumber(account?.bank_acc_no)}
              subText={"Account number"}
              fontWeight={"normal"}
              textColor={"var(--text-primary)"}
              iconComponentArray={[
                ...(account?.favourite === "Y"
                  ? [
                      {
                        icon: ICONS?.FAVOURITE_FILLED,
                        title: "Favourite account",
                        isDisabled: false,
                      },
                    ]
                  : []),
              ]}
            />
            <TextWithBank
              text={account?.ifsc_code}
              subText={"IFSC"}
              fontWeight={"normal"}
              textColor={"var(--text-primary)"}
              ifscCode={account?.ifsc_code}
            />
          </card-body>
          <card-hover>
            <TextWithIcon
              text={account?.name}
              subText={"Account name"}
              fontWeight={"normal"}
              textColor={"var(--text-primary)"}
            />
            {successRefreshId.includes(account?.id) ? (
              <TextWithIcon
                currency={currency}
                isAbbrevation={true}
                balance={account?.difference?.toString()}
                type={"Amount"}
                text={account?.difference?.toString()}
                subText={`Balance ${account?.increaseOrDecrease === "" ? "increased" : account?.increaseOrDecrease} by`}
                fontWeight={"normal"}
                textColor={
                  account?.increaseOrDecrease === "increased"
                    ? "var(--settled)"
                    : account?.increaseOrDecrease === "decreased"
                      ? "var(--failed)"
                      : "var(--text-primary)"
                }
              />
            ) : null}
            <TextWithIcon
              text={
                failedRefreshId.includes(account?.id)
                  ? "Currently unable to fetch balance details. Please try again later."
                  : account?.owner_account_balance_last_fetched_at_in_words
                    ? account?.owner_account_balance_last_fetched_at_in_words.toLowerCase()
                    : "Not applicable"
              }
              subText={"Balance updated"}
              fontWeight={"normal"}
              textColor={
                failedRefreshId.includes(account?.id)
                  ? "var(--emphasis)"
                  : "var(--text-primary)"
              }
            />
            <TextWithIcon
              text={
                account?.tags?.length
                  ? account?.tags?.join(", ")
                  : "No tags assigned"
              }
              iconComponentArray={[
                {
                  icon: ICONS?.ASSIGN_TAG_WITHOUT_CIRCLE,
                  isDisabled: false,
                },
              ]}
              fontWeight={"normal"}
              textColor={"var(--text-primary)"}
            />
            <TextWithIcon
              text={
                account?.labels?.length
                  ? account?.labels?.join(", ")
                  : "No labels assigned"
              }
              iconComponentArray={[
                {
                  icon: ICONS?.LABEL,
                  isDisabled: false,
                },
              ]}
              fontWeight={"normal"}
              textColor={"var(--text-primary)"}
            />
          </card-hover>
        </CardContainer>
      </div>
    </>
  );
};

export default OwnerAccountGridViewComp;
